import {
	Component,
	EventEmitter,
	Input,
	Output,
	ViewEncapsulation,
} from '@angular/core';

@Component({
	encapsulation: ViewEncapsulation.None,
	selector: 'app-modal',
	styleUrls: ['./modal.component.scss'],
	templateUrl: './modal.component.html',
})
export class ModalComponent {
	// TODO starting to replace dialog.component to avoid problems (styling and scrolling) due to many dimensional and behavior changes in dialogs in the first design system

	@Input() public btnDisabled = false;
	@Input() public btnLabel = '';

	@Output() modalAction = new EventEmitter<void>();
	@Output() modalClose = new EventEmitter<void>();
	@Input() public modalTitle = '';
	@Input() public size = 'sm'; // sm: 560x540px
}
